// Fixed height for each chain item.
export const CHAIN_ITEM_HEIGHT = 32;
